{
  "name": "taas-ts-frontend-angular",
  "version": "0.3.0",
  "scripts": {
    "ng": "ng",
    "lint": "ng lint",
    "test": "ng test --no-watch",
    "start": "ng serve",
    "start-prod": "ng serve --configuration=production",
    "start-preprod": "ng serve --configuration=preprod",
    "start-de": "ng serve --configuration=de",
    "start-en": "ng serve --configuration=en",
    "start-se": "ng serve --configuration=se",
    "translate": "ng extract-i18n",
    "build": "ng build",
    "build:stats": "ng build --stats-json && esbuild-visualizer --metadata ./dist/taas-ts-frontend-angular/stats.json --filename ./dist/taas-ts-frontend-angular/stats.html && open-cli ./dist/taas-ts-frontend-angular/stats.html",
    "build-prod": "ng build --configuration=production",
    "build-preprod": "ng build --configuration=preprod",
    "build-dev": "ng build --configuration=development",
    "watch": "ng build --watch --configuration=development"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.1.5",
    "@angular/cdk": "^21.1.5",
    "@angular/common": "^21.1.5",
    "@angular/compiler": "^21.1.5",
    "@angular/core": "^21.1.5",
    "@angular/forms": "^21.1.5",
    "@angular/material": "^21.1.5",
    "@angular/platform-browser": "^21.1.5",
    "@angular/platform-browser-dynamic": "^21.1.5",
    "@angular/router": "^21.1.5",
    "@material-icons/svg": "1.0.33",
    "chart.js": "^4.4.5",
    "jwt-decode": "^4.0.0",
    "keycloak-angular": "^21.0.0",
    "keycloak-js": "^26.2.3",
    "rxjs": "~7.8.0",
    "tslib": "^2.8.1",
    "utimaco-common-ui-angular": "https://repo.fra1.us.utimaco.cloud/repository/npm-hosted/utimaco-common-ui-angular/-/utimaco-common-ui-angular-1.16.7.tgz",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.2.0",
    "@angular-eslint/eslint-plugin": "^21.2.0",
    "@angular-eslint/eslint-plugin-template": "^21.2.0",
    "@angular-eslint/schematics": "^21.2.0",
    "@angular-eslint/template-parser": "^21.2.0",
    "@angular/build": "^21.1.5",
    "@angular/cli": "^21.1.5",
    "@angular/compiler-cli": "^21.1.5",
    "@angular/localize": "^21.1.5",
    "@eslint/js": "^9.39.3",
    "@types/chart.js": "^2.9.41",
    "@types/jasmine": "~5.1.9",
    "@typescript-eslint/eslint-plugin": "^8.33.1",
    "@typescript-eslint/parser": "^8.33.1",
    "angular-eslint": "^21.2.0",
    "esbuild-visualizer": "^0.7.0",
    "eslint": "^9.39.3",
    "jasmine-core": "~5.1.2",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ng-extract-i18n-merge": "^3.3.0",
    "open-cli": "^8.0.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.56.1"
  },
  "overrides": {
    "tar": "7.5.8"
  }
}
